import { createApp } from 'vue'
import Work from './Work.vue'
import router from '../../router/mobileMenu.router'


createApp(Work).use(router).mount('#work')

